var PolarisDrive = (function () {
    let successCallback;
    let fileLayer, filePrjList;

    // 탐색기
    let b_execute_left = false; // 이중방지
    let pg_no_left = 1; // 페이지
    let pg_per_cnt_left = 50; // 페이지 건수
    let next_yn_left = "Y"; // 다음페이지 존재하는 여부.

    // 본문
    let b_execute = false; // 이중방지
    let pg_no = 1; // 페이지
    let pg_per_cnt = 30; // 페이지 건수
    let next_yn = "Y"; // 다음페이지 존재하는 여부.
    let isFirst = true;
    let isFirstFld = true;

    let checked_file_json = {}; // 체크된 파일
    let select_colabo_file_count_json = {}; // 선택된 파일 cnt
    let download_file_json = {};
    let active_api_json = {}; // 실행중인 API

    let contentsLayer;
    let fileArray;

    return {
        open: open,
    }

    function open(callback) {
        if (!ServerChecker.isKogas || !Mutil.isFunc('POLARIS_DOCS')) return;
        submitCallback = callback;
        initSetting();
        addClickEvent(); // 클릭이벤트
        fileLayer.show();

        $('body').attr('oncontextmenu', 'return false');
    }

    function initSetting() {
        layerSettings();
        dataSettings();
    }

    function layerSettings() {
        fileLayer = $("#flow-file-box-layer");
        filePrjList = fileLayer.find(".proj_file_list");
        contentsLayer = fileLayer.find(".fileTbl_content");
        const inputJson = {
            USER_ID: _USER_ID,
            RGSN_DTTM: _RGSN_DTTM,
            DOC_ID: '',
        }

        // 탐색기 포맷 선택 초기
        fileLayer.find('.option_format .check').remove();
        fileLayer.find('.option_format').hide();
        fileLayer.find('#selected_format').removeClass().addClass('ico01')
        fileLayer.find('#selected_format').text(fileLayer.find('.option_format a.ico01').text());
        fileLayer.find('#selected_format').append($('<span class="check"></span>'));
        fileLayer.find('#selected_format').show();
        $('#customDateDiv').hide();

        fileLayer.find(".fileTbl_content").empty();
        fileLayer.find("#file-search-bar").hide();
        fileLayer.find("#file-detail-layer").hide();
        fileLayer.find(".input_search_in[pause-srch-bar]").prop('pause-srch-bar', false).show();
        getPolarisFile(inputJson);
        fileLayer.find('.proj_file_list').attr('doc_id', '-1').addClass('on');
        fileLayer.find('.flow_file_btn_wrap .selectedCount').text(i18next.t(common.countSelect, {count: 0}));
    }

    function getPolarisFile(inputJson, upDocId = '-1') {
        if (inputJson.DOC_ID === '-1') {
            inputJson.DOC_ID = '';
        }
        Ajax.executeApi('ACT_GET_POLARIS_FILE', inputJson,function (dat) {
            drawFileList(dat);
            drawFolderList(dat, upDocId);
        })
    }

    function drawFileList(dat) {
        let fileList = [];
        fileLayer.find(".proj_file_list .famano_search").remove();
        fileLayer.find(".fileTbl_scroll .fileTbl_content").empty();
        setMscroll(fileLayer.find(".fileTbl_scroll"), function () {});

        $.each(dat.FILE_REC, function (i, v) {
            if (v.FILE_TYPE !== 'FILE') return;
            fileList.push(v.DOC_ID);
            v.DRIVE_ATCH_SRNO = v.DOC_ID;

            if (contentsLayer.find(`.fileTable-tr[doc_id="${v.DOC_ID}"]`).length <= 0) {
                fileLayer.find(".fileTbl_scroll .fileTbl_content").append(drawListComp(v));
            }
            if (!dat.FILE_FLD_SRNO && !select_colabo_file_count_json[v.DOC_ID]) {
                select_colabo_file_count_json[v.DOC_ID] = [];
            }
        });
        if (fileList.length === 0) fileLayer.find(".fileTbl_scroll .fileTbl_content").append(dataListEmpty());
    }

    function drawFolderList(dat, upDocId) {
        if (upDocId === '-1') fileLayer.find(".proj_file_list .depth01").empty();
        setMscroll(fileLayer.find(".file_menu_scroll"), function () {});

        $.each(dat.FILE_REC, function (i, v) {
            if (v.FILE_TYPE !== 'DIR') return;
            var tmpLiObj = $(`<li><a style="cursor:pointer"><span class="arr"></span><em class="yellow"></em>
                <span class="title off"></span><span id="selectFileCount"></span></a></li>`);
            tmpLiObj.attr('doc_id', v.DOC_ID);
            tmpLiObj.addClass(`js-folder-tree-${v.DOC_ID}`);
            tmpLiObj.find('.title').text(v.FILE_NM);

            // 파일폴더 리스트 가져오기
            tmpLiObj.off('click').on('click', function (e) {
                e.stopPropagation();
                selectFld(v.DOC_ID);
            });

            // 하위폴더 가져오기
            tmpLiObj.find('.arr').off('click').on('click', function (e) {
                e.stopPropagation();
                clickExplorerArrow(v.DOC_ID);
            });
            tmpLiObj.find('.arr').css('height', '7px');

            if (isFirst) {  // 최초 실행
                var colaboArray = [];
                select_colabo_file_count_json[v.DOC_ID] = colaboArray;
            }

            // HTML 붙이기
            if (upDocId === '-1') fileLayer.find(".proj_file_list .depth01").append(tmpLiObj);
        });
    }

    function dataSettings() {
        checked_file_json = {};
    }

    function addClickEvent() {
        // 전체 폴더 - 버튼
        fileLayer.find('.proj_file_list a:first').off('click').on('click', function (e) {
            e.stopPropagation();
            selectFld('-1');
        });
        // 전체 폴더 = 화살표
        fileLayer.find('.proj_file_list .arr:first').off('click').on('click', function (e) {
            e.stopPropagation();
            clickExplorerArrow('-1');
        });
        // 파일 업로드
        fileLayer.find('#successBtn').off('click').on('click', function () {
            var jsonFileLangth = Object.keys(checked_file_json).length;
            if (jsonFileLangth === 0) {
                Often.toast("error", i18next.t(main.alert.checkMoreThanOne));
                return;
            }

            if (_RESPONSE_TYPE === "CHAT") {
                // C_flowDriveFileUpload("FILE", checked_file_json);
            } else if (_RESPONSE_TYPE === "POST") {
                P_polarisDriveFileUpload(checked_file_json);
            }
        });
        // 전체 해제
        fileLayer.find('#cancleBtn').off('click').on('click', function () {
            var checkedFileCount = Object.keys(checked_file_json).length;
            if (checkedFileCount > 0) {
                uncheckedAllItem();
                jsonInit();
                fileLayer.find('.flow_file_btn_wrap .selectedCount').text(i18next.t(common.countSelect, {count: 0}));
                Often.toast("success", i18next.t(dictionary.deselect));
            } else if (checkedFileCount < 1) {
                Often.toast("error", i18next.t(main.alert.noFileSelected));
            }
        });
    }

    function jsonInit() {
        checked_file_json = {};
        $.each(select_colabo_file_count_json, function (v) {
            var selectColaboFile = filePrjList.find(`li[doc_id="${v.DOC_ID}"] #selectFileCount`);
            selectColaboFile.text("");
            select_colabo_file_count_json[v] = [];
        });
    }

    function P_polarisDriveFileRec(ATCH_REC) {
        let atchRec = {
            "ATCH_SRNO": Often.null2Void(ATCH_REC.ATCH_SRNO),
            "RAND_KEY": Often.null2Void(ATCH_REC.RAND_KEY),
            "FILE_SIZE": Often.null2Void(ATCH_REC.FILE_SIZE, '-'),
            "FILE_NM": Often.null2Void(ATCH_REC.FILE_NM),
            "USE_INTT_ID": Often.null2Void(ATCH_REC.USE_INTT_ID, _USE_INTT_ID),
            "ATCH_URL": Often.null2Void(ATCH_REC.ATCH_URL),
            "FILE_STRG_PATH": Often.null2Void(ATCH_REC.FILE_STRG_PATH),
            "FILE_DOWN_URL": Often.null2Void(ATCH_REC.ATCH_URL),
            "THUM_IMG_PATH": Often.null2Void(ATCH_REC.THUM_IMG_PATH),
            "FILE_INTT_ID": Often.null2Void(ATCH_REC.USE_INTT_ID),
            "DATA_CODE": Often.null2Void(ATCH_REC.MSG_GB),
            "DOC_ID": ATCH_REC.DOC_ID,
            "POLARIS_BADEG": "true",
        }
        return atchRec;
    }

    function P_polarisDriveFileUpload(ATCH_REC) {
        fileArray = [];
        $.each(ATCH_REC, function (i) {
            ATCH_REC[i].MSG_GB = "F";
            let makeFileRecObj = P_polarisDriveFileRec(ATCH_REC[i]);
            fileArray.push(makeFileRecObj);
        });
        (typeof submitCallback === "function") && submitCallback(fileArray, "PROJECT");
    }

    function uncheckedAllItem() {
        fileLayer.find('input#lbchk01').prop("checked", false);
        fileLayer.find('.fileTable-tr').find('input#lbchk02').prop("checked", false);
        fileLayer.find('.fileTable-tr').find('.bd_on').remove();
        drawThumbOpacityLayer(false, fileLayer.find('.fileTable-tr'));
        drawSelectedCnt();
    }

    // 왼쪽영역 아이템 클릭
    function selectFld(docId, type) {
        if (!isApiExecutable()) {
            Often.toast("error", i18next.t(common.wait));
            return;
        }

        if (!getTargetObj(docId, type).hasClass('on')) {
            var tmpObj = getTargetObj(docId, type);

            if (docId !== '-1' && Often.null2Void(tmpObj.find(".arr:first").css('transform')) === "none" && type !== "MOVE") {
                clickExplorerArrow(docId, type);
            }

            tmpObj.parents('.sub.folder').find('li.on').removeClass('on');
            fileLayer.find(".sub.folder").find(".title").css("font-weight", "inherit");
            tmpObj.addClass('on');

            if (Often.null2Void(docId, '-1') !== '-1' && !(Often.null2Void(docId, '') === '' && type === "MOVE")) {
                tmpObj.find(".title:first").css("font-weight", "600");
            }

            const inputJson = {
                USER_ID: _USER_ID,
                RGSN_DTTM: _RGSN_DTTM,
                DOC_ID: docId,
                PG_NO: "1",
                COUNT: "600",
            }
            getPolarisFile(inputJson, docId);
        }
    }

    function getFldListInList(b_init) {
        var tmpDocId = Often.null2Void(getTargetObj('', 'ON').attr('doc_id'));

        if (b_init) {
            if (fileLayer.find("#selected_format").attr('class') === 'ico01') {
                getFldList(tmpDocId, "CENTER");
            }
        }
        return "";
    }

    // 파일폴더리스트
    function getList(b_init) {
        if (b_init === undefined || b_init) init_pg();
        if (b_execute) return;

        if (pg_no === 1) {
            fileLayer.find(".fileTbl_scroll .fileTbl_content").empty();
            setKeyWhenDrawOnView('');
        } else {
            b_execute = true;
        }

        // 실행전 키
        var KEY_BEFORE_RUN = Often.null2Void(getTargetObj('', 'ON').attr('doc_id'));
        addActiveApi(KEY_BEFORE_RUN);

        getFldListInList(b_init);

        // 폴더 리스트 가져오기

        loading();
        loadingStop();
        deleteEndApi(KEY_BEFORE_RUN);

        var KEY_WHEN_DRAW = getKeyWhenDraw();

        if (pg_no === 1) {
            if (KEY_WHEN_DRAW !== KEY_BEFORE_RUN || getKeyWhenDrawOnView() === KEY_BEFORE_RUN) return;
        }

        if (dat.ATCH_REC.length === 0 && pg_no === 1 && fileLayer.find(".fileTbl_scroll .fileTbl_content .fileTable-tr").length === 0) {
            fileLayer.find(".fileTbl_scroll .fileTbl_content .famano_search").remove();
            fileLayer.find(".fileTbl_scroll .fileTbl_content").append(fn_Blank());
        } else {
            fileLayer.find(".fileTbl_scroll .fileTbl_content").removeClass('type2');

            var contentsLayer = fileLayer.find(".fileTbl_content");

            $.each(dat.ATCH_REC, function (i, v) {
                v.DRIVE_ATCH_SRNO = v.DOC_ID;

                if (contentsLayer.find(`.fileTable-tr[doc_id="${v.DOC_ID}"]`).length > 0) {
                } else {
                    fileLayer.find(".fileTbl_scroll .fileTbl_content").append(drawListComp(v));
                }
                if (!dat.FILE_FLD_SRNO && !select_colabo_file_count_json[v.DOC_ID]) {
                    select_colabo_file_count_json[v.DOC_ID] = [];
                }
            });
        }

        fileLayer.find('.filemoa-top .srch_rslt').hide();
        fileLayer.find('.filemoa-top .flmaTop_list').show();

        next_yn = dat.NEXT_YN;
        pg_no++;
        b_execute = false;

        drawSelectedCnt();
        setKeyWhenDrawOnView(KEY_WHEN_DRAW);

        // 영역을 다 채우지 못하며 한번더!
        if (next_yn === "Y") {
            setTimeout(function () {
                if (fileLayer.find("#collabo3File").is(":visible") && fileLayer.find('.fileTbl_scroll').height() > fileLayer.find('.fileTbl_content').height()) {
                    getList(false);
                }
            }, 100)
        }
    }

    /*
     * START
     *
     * 같은 전문이 변수만 바뀌면서 동시요청이 여러번 들어왔을때 마지막으로 요청한 전문이 그려지고 요청되어 실행되는 전문이 4개 이상일
     * 경우 동작을 막는다.
     *
     * END 일경우 + 1 해준다 (그래야 당일꺼도 나옴)
     */
    function addActiveApi(key) {
        active_api_json[Time.currentTime("type22")] = key;
    }

    function deleteEndApi(key) {
        for (var k in active_api_json) {
            if (key === active_api_json[k]) {
                delete active_api_json[k];
            }
        }
    }

    function getKeyWhenDraw() {
        return Often.null2Void(getTargetObj('', 'ON').attr('doc_id'));
    }

    function setKeyWhenDrawOnView(key) {
        fileLayer.find(".fileTbl_scroll").attr("draw_srno_key", Often.null2Void(key));
    }

    function getKeyWhenDrawOnView() {
        return Often.null2Void(fileLayer.find(".fileTbl_scroll").attr("draw_srno_key"));
    }

    function isApiExecutable() {
        return (Object.keys(active_api_json).length < 4);
    }
    /* END */

    function drawListComp(v) {
        var b_list = isListView();

        var tmpLiObj = $(fileLayer.find('#fileTbl_item').html());

        tmpLiObj.attr('doc_id', v.DOC_ID);
        tmpLiObj.css('cursor', 'pointer');
        tmpLiObj.find('.format_icon input').css('cursor', 'pointer');
        tmpLiObj.find('.move_helper_text').text(v.FILE_NM);
        tmpLiObj.find('.title').val(v.FILE_NM);
        tmpLiObj.find('.rgsr-nm').text(v.USER_NM);
        tmpLiObj.find('.rgsn-dttm').text(v.LAST_DTTM);
        tmpLiObj.find('.format_icon').removeClass('collect_file_security').removeClass('security_v1');
        if (v.DRM_YN === "Y") {
            tmpLiObj.find('.format_icon').addClass('collect_file_security');
            if (b_list) {
                tmpLiObj.find('.format_icon').addClass('security_v1');
            }
        }

        // 썸네일
        var fileEtsNm = getFileIcon(Often.null2Void(v.FILE_NM));
        tmpLiObj.find('.format_icon').css("background-image", "url(" + fileEtsNm + ")");

        // 더블클
        tmpLiObj.off('click').on('click', function (e) {
            addItemLeftClickEvent("FILE", e, $(this));
        });

        // 체크버튼 처리
        tmpLiObj.find('.one-check').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (Object.keys(checked_file_json).length === 5) {
                Often.toast("error", i18next.t(common.maximum, {count: 5, val: $t(dictionary.file)}));
                return;
            }
            if ($(this).find('input#lbchk02').is(":checked")) {
                $(this).find('input#lbchk02').prop("checked", false);
                $(this).parents('.fileTable-tr').find('.bd_on').remove();
                drawThumbOpacityLayer(false, $(this).parents('.fileTable-tr'));
                delete checked_file_json[v.DOC_ID];
                select_colabo_file_count_json[v.DOC_ID].pop(v.DOC_ID);
            } else {
                $(this).find('input#lbchk02').prop("checked", true);
                $(this).parents('.fileTable-tr').prepend($('<span class="bd_on"></span>'))
                drawThumbOpacityLayer(true, $(this).parents('.fileTable-tr'));
                checked_file_json[v.DOC_ID] = v;
                select_colabo_file_count_json[v.DOC_ID].push(v.DOC_ID);
            }

            drawSelectedCnt();
        });

        // 전체선택 중이라면
        if (fileLayer.find('.total-check, .total-check2').find('input#lbchk01').is(":checked")) {
            tmpLiObj.find('input#lbchk02').prop("checked", true);
            tmpLiObj.prepend($('<span class="bd_on"></span>'));

            drawThumbOpacityLayer(true, tmpLiObj);
        }

        if (Object.keys(checked_file_json).length > 0 && JSON.stringify(checked_file_json).indexOf(v.DOC_ID) > -1) {
            var targetEl = $(`.fileTable-tr[doc_id="${v.DOC_ID}"]`);
            tmpLiObj.find('input#lbchk02').prop("checked", true);
            tmpLiObj.prepend($('<span class="bd_on"></span>'))
            drawThumbOpacityLayer(true, tmpLiObj);
        }
        return tmpLiObj;
    }

    function drawThumbOpacityLayer(b_show, target) {
        var tmpObj;
        if ("" !== Often.null2Void(target)) {
            tmpObj = target;
        } else {
            tmpObj = fileLayer.find(".fileThumb.filemoaTbl .fileTable-tr.img-file .bd_on").parent();
        }

        if (tmpObj.hasClass('img-file')) {
            if (b_show) {
                tmpObj.find('.cell02 .bg').css('opacity', '1');
                tmpObj.find('.cell02').css({
                    'background': '#efeef8',
                    'height': '100%'
                });
            } else {
                tmpObj.find('.cell02 .bg').css('opacity', '1');
                tmpObj.find('.cell02').css({
                    'background': 'rgba(116,105,254,0)',
                    'height': '100%'
                });
            }
        }
    }

    function drawSelectedCnt() {
        // 전체선택 중이라면
        var tmpNum = 0;
        var b_all = fileLayer.find(isListView() ? '.total-check2' : '.total-check').find('input#lbchk01').is(":checked");
        if (b_all) {
            tmpNum = fileLayer.find('.bd_on').length - 1 < ((pg_no - 1) * pg_per_cnt) ? fileLayer.find('.bd_on').length - 1 : ((pg_no - 1) * pg_per_cnt);
        } else tmpNum = fileLayer.find('.bd_on').length;

        fileLayer.find('.flow_file_btn_wrap .selectedCount').text(i18next.t(common.countSelect, {count: Object.keys(checked_file_json).length}));

    }

    function fn_Blank(type, where) {
        var tmpObj;
        if (where === "LEFT") {
            tmpObj = $('<div class="famano_search side"><h2></h2></div>');
        } else {
            tmpObj = $('<div class="famano_search"><h2></h2></div>');
        }
        tmpObj.find('h2').text(i18next.t(common.noResult));
        return tmpObj;
    }

    function init_pg() {
        pg_no = 1;
        next_yn = "Y";

        setMscroll(fileLayer.find(".fileTbl_scroll"), function () {
            if (next_yn === "Y") {
                getList(false);
            }
        });
    }

    function getDepthClass(docId, type) {
        if (Often.null2Void(type, "LEFT") === "LEFT" || Often.null2Void(type, "LEFT") === "MOVE") {
            return 'depth0' + (Number(Often.null2Void(getTargetObj(docId, type).parent().attr('class')).replace('depth0', '')) + 1);
        }
        return "";
    }

    // 하위폴더리스트
    function getFldList(docId, type) {
        if ("" === Often.null2Void(docId)) return;

        var fldArr = [];
        const inputJson = {
            USER_ID: _USER_ID,
            RGSN_DTTM: _RGSN_DTTM,
            DOC_ID: docId,
            PG_NO: "1",
            COUNT: "600",
        }

        Ajax.executeApi('ACT_GET_POLARIS_FILE', inputJson,function (dat) {
            if (dat.FILE_REC.length !== 0) {
                var tmpDepthClass = getDepthClass(docId, type);

                if (Often.null2Void(type, "LEFT") === "LEFT" || Often.null2Void(type, "LEFT") === "MOVE") {
                    if (getTargetObj(docId, type).find('ul.' + tmpDepthClass).length === 0) {
                        getTargetObj(docId, type).append($('<ul class="' + tmpDepthClass + '"><ul>'));
                    } else {
                        getTargetObj(docId, type).find('ul.' + tmpDepthClass).empty();
                    }
                }

                $.each(dat.FILE_REC, function (i, v) {
                    if (v.FILE_TYPE !== 'DIR') return;
                    v.TYPE = Often.null2Void(type, "LEFT");
                    v.UP_DOC_ID = docId;
                    if (!select_colabo_file_count_json[v.DOC_ID]) {
                        var fileFldArray = [];
                        select_colabo_file_count_json[v.DOC_ID] = fileFldArray;
                    }
                    if (Often.null2Void(type, "LEFT") === "LEFT" || Often.null2Void(type, "LEFT") === "MOVE") {
                        getTargetObj(docId, type).find('ul.' + tmpDepthClass).append(drawFldListComp(v));
                    } else {
                        fileLayer.find(".fileTbl_content").append(drawFldListComp(v));
                    }
                    fldArr.push({
                        "FILE_FLD_SRNO": v.DOC_ID
                    });
                });
                isFirstFld = false;
            }
        });

        return fldArr;
    }

    function drawFldListComp(v) {
        let tmpType = v.TYPE;
        let docId = v.DOC_ID;
        let upDocId = v.UP_DOC_ID
        let tmpLiObj;

        if (tmpType === "LEFT" || tmpType === "MOVE") {
            tmpLiObj = $('<li><a style="cursor:pointer"><span class="arr"></span><em></em><span class="title off"></span><span id="selectFileCount"></span></a></li>');
            tmpLiObj.attr('doc_id', docId)
            tmpLiObj.attr('UP_FILE_FLD_SRNO', upDocId);
            tmpLiObj.find('.title').text(v.FILE_NM);
            tmpLiObj.find('em').addClass('yellow');

            // 파일폴더 리스트 가져오기
            tmpLiObj.off('click').on('click', function (e) {
                e.stopPropagation();
                selectFld(docId, tmpType);
            });

            // 더블클릭
            tmpLiObj.off('dblclick').on('dblclick', function (e) {
                e.stopPropagation();
                clickExplorerArrow(docId, tmpType);
            });

            // 하위폴더 가져오기
            if ("Y" === v.LAST_FLD_YN) {
                tmpLiObj.find('.arr').off('click').on('click', function (e) {
                    e.stopPropagation();
                    clickExplorerArrow(docId, tmpType);
                }).css('height', '7px');
            } else {
                tmpLiObj.find('.arr').css('height', '0px');
            }

        } else if (tmpType === "CENTER" || tmpType === "SRCH") {
            tmpLiObj = $($('#fileTbl_item').html());
            tmpLiObj.attr('doc_id', docId).attr('up-file-fld-srno', upDocId);
            tmpLiObj.find('.move_helper_text').text(v.FILE_NM);
            tmpLiObj.find('.title').val(v.FILE_NM);

            tmpLiObj.find('.title').off('keydown').on('keydown', function () {
                if ($(this).val().length === 50) {
                    Often.toast("error", i18next.t(main.placeHolder.lengthLimit, {count: 50}));
                }
            });

            tmpLiObj.find('.rgsr-nm').html(convertText2Html2(v.USER_NM));
            tmpLiObj.find('.rgsn-dttm').text(v.LAST_DTTM);
            tmpLiObj.find('.format_icon').css({
                "background-image": "url(/design2/img_rn/filemoa/filemoa_bico01.png)",
                "background-size": "30px 25px"
            });
            tmpLiObj.css('cursor', 'pointer');
            tmpLiObj.find('.format_icon input').css('cursor', 'pointer');

            // 클릭이벤트
            tmpLiObj.off('dblclick').on('dblclick', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (Often.null2Void(getTargetObj(v.DOC_ID, 'LEFT').find('.arr').css('transform'), 'none') === 'none') {
                    getTargetObj(v.DOC_ID, 'LEFT').find('.arr').click();
                }
                selectFld(v.DOC_ID);

            }).off('click').on('click', function (e) {
                addItemLeftClickEvent("FLD", e, $(this), v);
            });

            // 체크버튼 처리
            tmpLiObj.find('.one-check').off('click').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                fileLayer.find(".one-more-layer").hide();
                if ($(this).find('input#lbchk02').is(":checked")) {
                    $(this).find('input#lbchk02').prop("checked", false);
                    $(this).parents('.fileTable-tr').find('.bd_on').remove();
                    drawThumbOpacityLayer(false, $(this).parents('.fileTable-tr'));
                } else {
                    $(this).find('input#lbchk02').prop("checked", true);
                    $(this).parents('.fileTable-tr').prepend($('<span class="bd_on"></span>'))
                    drawThumbOpacityLayer(true, $(this).parents('.fileTable-tr'));
                }
            });

            // 전체선택 중이라면
            if (fileLayer.find('.total-check, .total-check2').find('input#lbchk01').is(":checked")) {
                tmpLiObj.find('input#lbchk02').prop("checked", true);
                tmpLiObj.prepend($('<span class="bd_on"></span>'));
                drawThumbOpacityLayer(true, tmpLiObj);
            }
        }
        return tmpLiObj;
    }

    function addItemLeftClickEvent(type, e, target) {
        if ("fileTbl_chkbx" !== $(e.target).parent().attr('class')) {
            target.find('.one-check').click();
        }
    }

    // 왼쪽영역 화살표 클릭
    function clickExplorerArrow(docId, type) {
        var tmpObj = getTargetObj(docId, type);
        if (tmpObj.find('ul').find('li').length > 0 && tmpObj.find('ul').is(':visible')) {
            tmpObj.removeClass('on');
            tmpObj.find('ul').hide();
            tmpObj.find('.arr:first').css('transform', '');
        } else if (tmpObj.find('ul').find('li').length > 0 && !tmpObj.find('ul').is(':visible')) {
            tmpObj.find('ul').show();
            tmpObj.find('.arr:first').css('transform', 'rotate(90deg)');
        } else {
            getFldList(docId, type);
            tmpObj.find('ul').show();
            tmpObj.find('.arr:first').css('transform', 'rotate(90deg)');
        }
    }

    function convertText2Html2(str) {
        if (!str) {
            return "";
        }

        return str.replace(/</ig, "&lt;").replace(/>/ig, "&gt;");
    }

    function loading() {
        $('.fileTbl_content')
            .prepend(
                $('<div id="img_loading_bar" class="flow-circle-loader" style="top:300px;left:50%;position:absolute;margin-left:-15px;display:block;"></div>'));
    }

    function loadingStop() {
        $('.fileTbl_content #img_loading_bar').remove();
    }

    // 타겟오브젝트
    function getTargetObj(docId, type) {
        var tmpObj;
        if ("LEFT" === type) {
            tmpObj = fileLayer.find(".file_menu_scroll [doc_id=" + docId + "]");
        } else if ("MOVE" === type) {
            tmpObj = fileLayer.find(".ly_filemove [doc_id=" + docId + "]");
        } else if ("CENTER" === type) {
            tmpObj = fileLayer.find(".fileTbl_scroll [doc_id=" + docId + "]");
        } else if ("TOP" === type) {
            tmpObj = fileLayer.find(".up-category-item [doc_id=" + docId + "]");
        } else if ("ON" === type) {
            tmpObj = fileLayer.find(".file_menu_scroll .proj_file_list li.on");
        } else {
            tmpObj = fileLayer.find(".file_menu_scroll [doc_id=" + docId + "]");
        }
        return tmpObj;
    }

    function isListView() {
        return fileLayer.find('.list_or_thumb li.on').hasClass('list');
    }

    function getFileIcon(FILE_NM) {
        var file_img = "";
        var file_type = getFileType(FILE_NM);

        if (file_type.indexOf("DOC") > -1 || file_type.indexOf("DOCX") > -1) {
            file_img = "/design3/img_rn/ico/file_icon2_DOC.png";
        } else if (file_type.indexOf("HWP") > -1 || file_type.indexOf("HWPX") > -1) {
            file_img = "/design3/img_rn/ico/file_icon2_hwp.png";
        } else if (file_type.indexOf("XLS") > -1 || file_type.indexOf("XLSX") > -1) {
            file_img = "/design3/img_rn/ico/file_icon2_XLS.png";
        } else if (file_type.indexOf("PPT") > -1 || file_type.indexOf("PPTX") > -1) {
            file_img = "/design3/img_rn/ico/file_icon2_PPT.png";
        } else {
            file_img = "/design3/img_rn/ico/file_icon2_down.png";
        }
        return file_img;
    }

    // 파일타입 구하는 함수
    function getFileType(file_name) {
        var startIndex = file_name.lastIndexOf(".") + 1;
        var lastIndex = file_name.length;
        var fileType = file_name.substring(startIndex, lastIndex).toUpperCase();
        if (startIndex === 0) {
            fileType = i18next.t(dictionary.file);
        }
        return fileType;
    }

    // 파일 없을 때
    function dataListEmpty(where) {
        var tmpObj;
        if (where === "LEFT") {
            tmpObj = $('<div class="famano_search side"><h2></h2></div>');
        } else {
            tmpObj = $('<div class="famano_search"><h2></h2></div>');
        }
        tmpObj.find('h2').text(i18next.t(common.noResult));
        return tmpObj;
    }

    // ===========================

    function setMscroll(obj, scr_func) {
        obj.mCustomScrollbar("destroy");
        obj.mCustomScrollbar({
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                preventDefault: true,
                deltaFactor: "auto",
                scrollAmount: 40
            },
            callbacks: {
                whileScrolling: function () {
                    var pct = this.mcs.topPct;
                    if (pct >= 75) {
                        if (typeof scr_func == "function") {
                            scr_func();
                        }
                    }
                }
            }
        });
    }
})()
